export var htmlDecode = function (str) {
    var txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
};
